import { GridFilterItem } from "@mui/x-data-grid-pro";

export const shouldRemoveLocalFilter = (filter: GridFilterItem): boolean => {
  const operatorIsAnyOf = filter.operatorValue === "isAnyOf";
  const valueLength = Array.isArray(filter.value) ? filter.value.length : 0;
  const operatorIsWarning = filter.operatorValue === "hasWarning";
  const redundantOperatorIsAny = operatorIsAnyOf && valueLength === 0;
  const redundantOperatorIsWarning = operatorIsWarning && !filter.value;

  const redundantOperatorIsEmpty = filter.operatorValue === "isEmpty" && !filter.value;
  const redundantOperatorIsNotEmpty = filter.operatorValue === "isNotEmpty" && !filter.value;

  return (
    redundantOperatorIsAny ||
    redundantOperatorIsWarning ||
    redundantOperatorIsEmpty ||
    redundantOperatorIsNotEmpty ||
    filter.value === ""
  );
};
